var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2119_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 197,
    height: 197
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 197,
    fill: "url(#pattern0_2119_5)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2119_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 199,
    height: 197,
    fill: "#97A4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2119_5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2119_5",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2119_5",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/0lEQVR4nO2cS05bQRREa5AsJRJkk8mMAQaS1aBkCwxhFZkFLD6xoZAlT5Mny+3Uvc/nSDXvruq6/YxESwAAAAAAAAAAAH/ns6QrSXeSlpJ85FpuvbjcenMwPkr6LmldYNMuqvXWo41XQ/kg6brABt1EP0eHsCiwKTfTt1Hmf5L0p8CG3EwrSacjAjgrsBk31cWIAG4KbMRNdTsigF8FNuKmuh8RwGOBjbixCEAEED+FpgF5I8wIypvhgLgDRADxU+jODXgqsAk31uwCmCK9PgJQ3nQaoD6NnYQRJAIwd0CfSruY9ua5wCZMAHnjTQPy5ruhZjeC3EwEIAKIn0LTgLwR7jqCXgpswo1FACKA+Ck0Dfh/lXYxzW4ETZFeHwEobzoNUJ/GTlLtfwOmSK+PAJQ3nQaoT2MnYQSJAMwd0KfSLiZGkAiABuzDqsAp8jGPIAIQAZgG5KtsRlDefDfU7O4ANxMBqHkAvJAlAnCBUUIDlDeTEaS8odwB6iUuYeXM/00A6v9k2WuBGrupzmmAYuZv/oJwQgCKBbB5S3oI/BLWzub/GPl0MXeAdho7l6PfjSYA/dP0h+3XzmLUU8UjA/hyiAUdG2+Y3y8ATn4wAMwPBoD5wQAwPxgA5gcDwPwDg/lhOPlhGDthmPlhuHDD8LUThk/NMF/TCwAAANAMeQcp34GsguLK/QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4bdf6ae5384c6079e70484a9468a1b4c.svg";
export { ForwardRef as ReactComponent };